<template>
  <div class="classSignRecord">
    <div class="title">
      <h3>签到记录(班主任)</h3>
    </div>
    <div class="searchBox">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="上课时间">
          <el-date-picker
            v-model="searchForm.time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="班级">
          <el-input v-model="searchForm.className"></el-input>
        </el-form-item>
        <el-form-item label="课程名称">
          <el-input v-model="searchForm.courseName"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchBtn">查询</el-button>
          <el-button type="primary" @click="reSet">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table">
      <div class="content">
        <el-table :data="tableData" style="width: 100%"  v-loading="loading">
          <el-table-column type="index" label="序号" width="80" align="center">
          </el-table-column>
          <el-table-column prop="classname" label="班级" align="center">
          </el-table-column>
          <el-table-column prop="name" label="课程名称" align="center">
          </el-table-column>
          <el-table-column prop="teachers" label="授课老师" align="center">
          </el-table-column>
          <el-table-column prop="timeRange" label="上课时间" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.date}} {{scope.row.timeRange}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="knob" label="上课节次" align="center">
          </el-table-column>
          <el-table-column prop="classrooms" label="上课教室" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="row">
              <el-button size="mini" type="primary" plain @click="detail(row.row)"
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          @size-change="changeSize"
          @current-change="changePage"
          :current-page.sync="paramSearch.current"
          :page-sizes="pageSizes"
          :page-size.sync="paramSearch.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="签到详情"
      :visible.sync="visible"
      v-if="visible"
      width="80%"
      :append-to-body="true"
      >
      <RecordDetail :info="info"/>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import RecordDetail from "./classSignRecordDetail.vue";
// import treeMenu from "@/components/treeMenu/index.vue";
import { getClassTeacherAttendance } from "@/api/overseasChinese/overseasChinese"
export default {
  components: {
    RecordDetail,
    // treeMenu,
  },
  data() {
    return {
      tableData: [],
      searchForm: {
        time:[],
        className: "",
        courseName: "",
      },
      paramSearch: {
        current: 1,
        size: 20,
      },
      total: 0,
      pageSizes: [20, 50, 100],
      visible: false,
      value1: "",
      treeShow: false,
      loading: false,
      info:""
    };
  },
  created() {
  },
  mounted() {
    this.searchBtn()
  },
  methods: {
    //条件筛选
    initPage() {},
    //查询
    searchBtn() {
      this.loading = true;
      const params={
        startTime:this.searchForm.time[0]?this.searchForm.time[0]:"",
        endTime:this.searchForm.time[1]?this.searchForm.time[1]:"",
        className: this.searchForm.className,
        courseName: this.searchForm.courseName,
        size:this.paramSearch.size,
        current:this.paramSearch.current,
      }
      getClassTeacherAttendance(params)
      .then(res=>{
        if(res.data.success){
          this.tableData = res.data.data.records;
          this.paramSearch.current = res.data.data.current;
          this.total = res.data.data.total;
          this.loading=false
        }
      }).catch(res=>{
          this.loading=false
      })
    },
    //重置
    reSet() {
      this.searchForm = {
        time:[],
        className: "",
        courseName: "",
      }
      this.paramSearch = {
        current: 1,
        size: 20,
      }
      this.searchBtn()
    },
    //详情
    detail(val) {
      this.info = val
      this.visible = true;
    },
    changeSize(val) {
      this.paramSearch.size = val;
      this.searchBtn()
    },
    changePage(val) {
      this.paramSearch.current = val;
      this.searchBtn()
    },
  },
};
</script>
<style scoped lang="less">
.classSignRecord {
  width: 100%;
  height: 100%;
  .title {
    height: 50px;
  }
  .searchBox {
    height: 50px;
  }
  .table {
    height: calc(100vh - 150px);
    .content {
      height: calc(100vh - 200px);
    }
  }
}
</style>